import React from "react";
import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation.ts";
import { activeLegalEntityStatusOptionId, deactivatedLegalEntityStatusOptionId, getLegalEntityStatusOptions } from "./legalEntityFieldOptions.ts";

export interface LegalEntityStatusFieldProps {
    isActive: boolean;
    onChange: (isActive: boolean) => void;
    readOnly?: boolean;
    disabled: boolean;
    isLoading: boolean;
    errorText?: string;
}

function LegalEntityStatusField(props: LegalEntityStatusFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getLegalEntityStatusOptions(translateString)}
            selectedItem={props.isActive ? activeLegalEntityStatusOptionId : deactivatedLegalEntityStatusOptionId}
            onChange={props.readOnly ? () => {} : (status) => props.onChange(status === activeLegalEntityStatusOptionId)}
            placeholder={translateString("status")}
            label={translateString("status")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
            isLoading={props.isLoading && !props.readOnly}
            disableClearable
        />
    );
}

export default LegalEntityStatusField;
